import { useMemo } from "react";
import useSWR from "swr";

import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

export function FanJourneyFunnel() {
  const { data, isLoading } = useSWR("/marketing/analytics/funnel", fetcher);
  const stages = data?.stages ?? [];
  const dropoff = data?.dropoff ?? [];
  const recommendations = data?.recommendations ?? [];
  const maxValue = useMemo(() => Math.max(...stages.map((stage: any) => stage.value), 1), [stages]);

  return (
    <Card className="space-y-4 border-border/70 bg-background/40 p-4">
      <div>
        <p className="text-sm font-semibold text-foreground">Fan Journey Funnel</p>
        <p className="text-xs text-muted-foreground">From awareness to superfans.</p>
      </div>
      {isLoading ? (
        <p className="text-xs text-muted-foreground">Loading funnel…</p>
      ) : (
        <div className="space-y-3">
          {stages.map((stage: any) => (
            <div key={stage.label}>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{stage.label}</span>
                <span>{stage.value.toLocaleString()}</span>
              </div>
              <Progress value={(stage.value / maxValue) * 100} className="mt-1" />
            </div>
          ))}
        </div>
      )}
      <section>
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Drop-off analysis</p>
        <div className="mt-2 space-y-1 text-xs text-muted-foreground">
          {dropoff.map((entry: any) => (
            <p key={`${entry.from}-${entry.to}`}>
              {entry.from} → {entry.to}: {entry.dropoff_pct}% drop
            </p>
          ))}
          {!dropoff.length ? <p>No drop-off data.</p> : null}
        </div>
      </section>
      <section>
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Recommendations</p>
        <ul className="mt-2 list-disc pl-4 text-xs text-muted-foreground">
          {recommendations.map((rec: string) => (
            <li key={rec}>{rec}</li>
          ))}
          {!recommendations.length ? <li>No recommendations yet.</li> : null}
        </ul>
      </section>
    </Card>
  );
}
